module.exports = __webpack_public_path__ + "assets/follow-products-info.79581ac9.svg";